module.exports = __webpack_public_path__ + "img/stock.5b01c41c.svg";